<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li>
          <a class="link-effect" [routerLink]="['/solicitudes-contratista']">Mis Solicitudes</a>
        </li>
        <li><span class="link-effect">Completar Solicitud</span></li>
      </ol>
    </div>
  </div>
</div>
<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Completar Solicitud</h3>
    </div>

    <div class="block-content">
      <app-solicitud-master-progress [model]="itemSolicitud" [data]="itemSolicitud" [flujoCompleto]="itemSolicitud.aplicaPersonas"></app-solicitud-master-progress>
      <app-solicitud-master-edit-header [model]="itemSolicitud" [disabled]="itemSolicitud.idSolicitudPrevia != null || (itemSolicitud.idEstado != 2 && itemSolicitud.idEstado != 5)" [data]="itemSolicitud"></app-solicitud-master-edit-header>
    </div>

    <!-- <div class="block-content">
      <mat-divider class="engie-divider"></mat-divider>
    </div> -->

    <div class="block-content">
      <mat-divider class="engie-divider"></mat-divider>
      <mat-accordion class="seccion-solicitud" multi>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Personal
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="form-horizontal">
            <div class="form-group"
              *ngIf="itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 3 || itemSolicitud.idEstado == 5">
              <div class="col-sm-6 text-left">
                <mat-slide-toggle [(ngModel)]="itemSolicitud.aplicaPersonas" class="aplica"
                  [disabled]="itemSolicitud.idEstado == 3" *ngIf="itemSolicitud.idSolicitudPrevia != null">
                  <span *ngIf="itemSolicitud.aplicaPersonas">SI REQUIERE PERSONAS</span><span
                    *ngIf="!itemSolicitud.aplicaPersonas">NO
                    REQUIERE PERSONAS</span>
                </mat-slide-toggle>
              </div>
              <div class="col-sm-6 text-right" *ngIf="itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 5">
                <a class="btn btn-new" mat-raised-button (click)="openDialogPersonal()"
                  *ngIf="itemSolicitud.aplicaPersonas"><mat-icon>description</mat-icon> Agregar personal</a>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table mat-table #tablePersonal [dataSource]="itemSolicitud.personas"
              class="table table-striped table-vcenter" *ngIf="itemSolicitud.aplicaPersonas">
              <ng-container matColumnDef="nombre">
                <th mat-header-cell *matHeaderCellDef>Nombre</th>
                <td mat-cell *matCellDef="let element">
                  {{
                  element.nombres +
                  " " +
                  element.apellidoPaterno +
                  " " +
                  element.apellidoMaterno
                  }}
                </td>
              </ng-container>

              <ng-container matColumnDef="nroDocumentoIdentidad">
                <th mat-header-cell *matHeaderCellDef>Nro Documento Identidad</th>
                <td mat-cell *matCellDef="let element" class="centre">{{ element.nroDocumentoIdentidad }}</td>
              </ng-container>

              <ng-container matColumnDef="correo">
                <th mat-header-cell *matHeaderCellDef>Correo</th>
                <td mat-cell *matCellDef="let element">{{ element.correo }}</td>
              </ng-container>

              <ng-container matColumnDef="cargo">
                <th mat-header-cell *matHeaderCellDef>Cargo</th>
                <td mat-cell *matCellDef="let element">{{ element.cargo }}</td>
              </ng-container>

              <ng-container matColumnDef="cantidad_documentos">
                <th mat-header-cell *matHeaderCellDef>
                  Cantidad de documentos
                </th>
                <td mat-cell *matCellDef="let element" class="centre">
                  {{ element.documentos.length }}
                </td>
              </ng-container>

              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef>
                  Estado
                </th>
                <td mat-cell *matCellDef="let element" class="centre">
                  {{ element.estado }}
                </td>
              </ng-container>

              <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let element">
                  <ng-container
                    *ngIf="itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 3 || itemSolicitud.idEstado == 5">
                    <button mat-icon-button color="primary" aria-label="Editar" (click)="openDialogPersonal(element)"
                      *ngIf="(element.idEstado == 0 && (itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 5)) || (element.idEstado == 2 && (itemSolicitud.idEstado == 3 || itemSolicitud.idEstado == 5))">

                      <mat-icon>create</mat-icon>
                    </button>

                    <button mat-icon-button color="primary" aria-label="Eliminar"
                      *ngIf="(element.idEstado == 0 && (itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 5)) || (element.idEstado == 2 && itemSolicitud.idEstado == 5)"
                      (click)="deletePersona(element)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </ng-container>

                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsPersonal"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsPersonal"></tr>
            </table>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Equipos
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="form-horizontal"
            *ngIf="itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 3 || itemSolicitud.idEstado == 5">
            <div class="form-group">
              <div class="col-sm-6 text-left">
                <mat-slide-toggle [(ngModel)]="itemSolicitud.aplicaEquipos" class="aplica"
                  [disabled]="itemSolicitud.idEstado == 3">
                  <span *ngIf="itemSolicitud.aplicaEquipos">SI REQUIERE EQUIPOS</span><span
                    *ngIf="!itemSolicitud.aplicaEquipos">NO REQUIERE EQUIPOS</span>
                </mat-slide-toggle>
              </div>

              <div class="col-sm-6 text-right" *ngIf="itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 5">
                <a class="btn btn-new" mat-raised-button (click)="openDialogEquipo()"
                  *ngIf="itemSolicitud.aplicaEquipos"><mat-icon>description</mat-icon> Agregar equipo</a>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table mat-table #tableEquipos [dataSource]="itemSolicitud.equipos"
              class="table table-striped table-vcenter" *ngIf="itemSolicitud.aplicaEquipos">
              <ng-container matColumnDef="equipo">
                <th mat-header-cell *matHeaderCellDef>Equipo</th>
                <td mat-cell *matCellDef="let element">{{ element.equipo }}</td>
              </ng-container>

              <ng-container matColumnDef="marca">
                <th mat-header-cell *matHeaderCellDef>Marca</th>
                <td mat-cell *matCellDef="let element">{{ element.marca }}</td>
              </ng-container>

              <ng-container matColumnDef="modelo">
                <th mat-header-cell *matHeaderCellDef>Modelo</th>
                <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
              </ng-container>

              <ng-container matColumnDef="serie">
                <th mat-header-cell *matHeaderCellDef>Serie</th>
                <td mat-cell *matCellDef="let element">{{ element.serie }}</td>
              </ng-container>

              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef>
                  Estado
                </th>
                <td mat-cell *matCellDef="let element" class="centre">
                  {{ element.estado }}
                </td>
              </ng-container>

              <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let element">
                  <ng-container
                    *ngIf="itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 3 || itemSolicitud.idEstado == 5">
                    <button mat-icon-button color="primary" aria-label="Editar" (click)="openDialogEquipo(element)"
                      *ngIf="(element.idEstado == 0 && (itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 5)) || (element.idEstado == 2 && (itemSolicitud.idEstado == 3|| itemSolicitud.idEstado == 5))">

                      <mat-icon>create</mat-icon>
                    </button>

                    <button mat-icon-button color="primary" aria-label="Eliminar" (click)="deleteEquipo(element)"
                      *ngIf="(element.idEstado == 0 && (itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 5)) || (element.idEstado == 2 && itemSolicitud.idEstado == 5)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </ng-container>

                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsEquipos"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsEquipos"></tr>
            </table>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Vehículos
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="form-horizontal"
            *ngIf="itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 3 || itemSolicitud.idEstado == 5">
            <div class="form-group">
              <div class="col-sm-6 text-left">
                <mat-slide-toggle [(ngModel)]="itemSolicitud.aplicaVehiculos" class="aplica"
                  [disabled]="itemSolicitud.idEstado == 3">
                  <span *ngIf="itemSolicitud.aplicaVehiculos">SI REQUIERE VEHÍCULOS</span><span
                    *ngIf="!itemSolicitud.aplicaVehiculos">NO REQUIERE VEHÍCULOS</span>
                </mat-slide-toggle>
              </div>
              <div class="col-sm-6 text-right" *ngIf="itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 5">
                <a class="btn btn-new" mat-raised-button (click)="openDialogVehiculo()"
                  *ngIf="itemSolicitud.aplicaVehiculos"><mat-icon>description</mat-icon> Agregar vehículo</a>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table mat-table #tableVehiculos [dataSource]="itemSolicitud.vehiculos"
              class="table table-striped table-vcenter" *ngIf="itemSolicitud.aplicaVehiculos">
              <ng-container matColumnDef="marca">
                <th mat-header-cell *matHeaderCellDef>Marca</th>
                <td mat-cell *matCellDef="let element">{{ element.marca }}</td>
              </ng-container>

              <ng-container matColumnDef="modelo">
                <th mat-header-cell *matHeaderCellDef>Modelo</th>
                <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
              </ng-container>

              <ng-container matColumnDef="placa">
                <th mat-header-cell *matHeaderCellDef>Placa</th>
                <td mat-cell *matCellDef="let element">{{ element.placa }}</td>
              </ng-container>

              <ng-container matColumnDef="color">
                <th mat-header-cell *matHeaderCellDef>Color</th>
                <td mat-cell *matCellDef="let element">{{ element.color }}</td>
              </ng-container>

              <ng-container matColumnDef="anio">
                <th mat-header-cell *matHeaderCellDef>Año</th>
                <td mat-cell *matCellDef="let element" class="centre">{{ element.anio }}</td>
              </ng-container>

              <ng-container matColumnDef="chofer">
                <th mat-header-cell *matHeaderCellDef>Chofer</th>
                <td mat-cell *matCellDef="let element">
                  {{
                  element.solicitudChofer.nombres +
                  " " +
                  element.solicitudChofer.apellidoPaterno +
                  " " +
                  element.solicitudChofer.apellidoMaterno
                  }}
                </td>
              </ng-container>

              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef>
                  Estado
                </th>
                <td mat-cell *matCellDef="let element" class="centre">
                  {{ element.estado }}
                </td>
              </ng-container>

              <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let element">
                  <ng-container
                    *ngIf="itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 3 || itemSolicitud.idEstado == 5">
                    <button mat-icon-button color="primary" aria-label="Editar" (click)="openDialogVehiculo(element)"
                      *ngIf="(element.idEstado == 0 && (itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 5)) || (element.idEstado == 2 && (itemSolicitud.idEstado == 3 || itemSolicitud.idEstado == 5))">

                      <mat-icon>create</mat-icon>
                    </button>

                    <button mat-icon-button color="primary" aria-label="Eliminar" (click)="deleteVehiculo(element)"
                      *ngIf="(element.idEstado == 0 && (itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 5)) || (element.idEstado == 2 && itemSolicitud.idEstado == 5)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </ng-container>

                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsVehiculos"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsVehiculos"></tr>
            </table>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Documentación Técnica
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="form-horizontal">
            <div class="form-group"
              *ngIf="itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 3 || itemSolicitud.idEstado == 5">
              <div class="col-sm-12 text-left">
                <mat-slide-toggle [(ngModel)]="itemSolicitud.aplicaDocumentacionTecnica" class="aplica"
                  [disabled]="itemSolicitud.idEstado == 3">
                  <span *ngIf="itemSolicitud.aplicaDocumentacionTecnica">SI REQUIERE DOCUMENTACIÓN TÉCNICA</span><span
                    *ngIf="!itemSolicitud.aplicaDocumentacionTecnica">NO REQUIERE DOCUMENTACIÓN TÉCNICA</span>
                </mat-slide-toggle>
              </div>
            </div>

            <div class="form-group">
              <div class="col-sm-12">

                <div class="table-responsive">
                  <table mat-table #tableDocumentosTecnicos [dataSource]="itemSolicitud.documentosTecnicos"
                    class="table table-striped table-vcenter" *ngIf="itemSolicitud.aplicaDocumentacionTecnica">
                    <ng-container matColumnDef="nombre">
                      <th mat-header-cell *matHeaderCellDef>Nombre</th>
                      <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
                    </ng-container>

                    <ng-container matColumnDef="idRequisito">
                      <th mat-header-cell *matHeaderCellDef>Requisito</th>
                      <td mat-cell *matCellDef="let element">{{ element.requisito }}</td>
                    </ng-container>

                    <ng-container matColumnDef="fechaVencimiento">
                      <th mat-header-cell *matHeaderCellDef>Fecha de vencimiento</th>
                      <td mat-cell *matCellDef="let element; let i = index">

                        <mat-form-field appearance="outline" *ngIf="element.controlarFechas">
                          <input matInput [matDatepicker]="pckrFechaVencimiento" [(ngModel)]="element.fechaVencimiento"
                            [name]="'fechaVencimiento_'+ i"
                            [disabled]="!((element.idEstado == 0 && (itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 5)) || (element.idEstado == 2 && (itemSolicitud.idEstado == 3 || itemSolicitud.idEstado == 5)))" />
                          <mat-datepicker-toggle matSuffix [for]="pckrFechaVencimiento"></mat-datepicker-toggle>
                          <mat-datepicker #pckrFechaVencimiento></mat-datepicker>
                        </mat-form-field>

                      </td>
                    </ng-container>

                    <ng-container matColumnDef="idDocumento">
                      <th mat-header-cell *matHeaderCellDef>Doc.</th>
                      <td mat-cell *matCellDef="let element">
                        <!-- <a>VER</a> -->
                        <a (click)="downloadDocumentFromService(element)">{{element.nombreArchivo}}</a>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="estado">
                      <th mat-header-cell *matHeaderCellDef>
                        Estado
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.estado }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="acciones">
                      <th mat-header-cell *matHeaderCellDef>Acciones</th>
                      <td mat-cell *matCellDef="let element">
                        <app-adjuntar-documento
                          *ngIf="(element.idEstado == 0 && (itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 5)) || (element.idEstado == 2 && (itemSolicitud.idEstado == 3 || itemSolicitud.idEstado == 5))"
                          [codigoSolicitud]="itemSolicitud.codigo" [filename]="element.nombreArchivo"
                          [idSolicitud]="itemSolicitud.idSolicitud" [model]="element" [tipoSeccion]="4"
                          (onUploadFinished)="addItem($event)">
                        </app-adjuntar-documento>

                        
                        <!-- <button mat-icon-button color="primary" aria-label="Eliminar" >
                            <mat-icon>delete</mat-icon>
                          </button> -->
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsDocumentosTecnicos"></tr>
                    <tr mat-row *matRowDef="
                        let row;
                        columns: displayedColumnsDocumentosTecnicos
                      "></tr>
                  </table>
                </div>
              </div>
            </div>

            <div class="form-group" *ngIf="itemSolicitud.aplicaDocumentacionTecnica">
              <label class="col-md-1 control-label">Comentarios Doc. Técnica:</label>
              <div class="col-md-11">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Comentarios Documentación Técnica:</mat-label>
                  <textarea matInput placeholder="Comentarios" rows="5" [(ngModel)]="comentarioDocumentacionTecnica"
                    name="comentarioDocTecnicoContratista" [maxlength]="2000"
                    [disabled]="!(itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 5 || (itemSolicitud.idEstado == 3 && itemSolicitud.idEstadoDocumentacionTecnica == 2))"></textarea>
                  <!-- [(ngModel)]="model.comentarioPorValidacion" -->
                  <!-- 
                    [disabled]="itemSolicitud.idEstadoDocumentacionTecnica === 2" -->
                </mat-form-field>

              </div>
            </div>

            <div class="form-group sec-lnkcomentarios" *ngIf="itemSolicitud.logsDocumentacionTecnica.length > 0">
              <label class="col-md-1 control-label"></label>
              <div class="col-md-4">
                <app-log-dialog-anchor [logs]="itemSolicitud.logsDocumentacionTecnica"></app-log-dialog-anchor>
              </div>
            </div>
            <div class="form-group" *ngIf="itemSolicitud.aplicaDocumentacionTecnica">
              <div class="col-sm-12 text-right">
                <a class="btn btn-new" mat-raised-button (click)="guardarDocumentosTecnicos()"
                  *ngIf="itemSolicitud.idEstado == 2 || itemSolicitud.idEstado == 5 || (itemSolicitud.idEstado == 3 && itemSolicitud.idEstadoDocumentacionTecnica == 2)"><mat-icon>description</mat-icon>
                  Guardar Documentos Técnicos</a>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- <mat-tab-group>
        <mat-tab label="Personal">
        </mat-tab>
        <mat-tab label="Equipos">
        </mat-tab>
        <mat-tab label="Vehiculos">
        </mat-tab>
        <mat-tab label="Documentación Técnica">
        </mat-tab>
      </mat-tab-group> -->
    </div>

    <div class="block-content">
      <mat-divider class="engie-divider"></mat-divider>
    </div>

    <div class="block-content" *ngIf="itemSolicitud.logs.length > 0">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-1 control-label">Comentarios Solicitud:</label>
          <div class="col-md-11">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Comentarios Solicitud:</mat-label>
              <textarea matInput placeholder="Comentarios" [(ngModel)]="itemSolicitud.comentarioPorCompletar" rows="5"
                name="comentarioPorValidacion" [maxlength]="2000"></textarea>
            </mat-form-field>

          </div>
        </div>

        <div class="form-group sec-lnkcomentarios">
          <label class="col-md-1 control-label"></label>
          <div class="col-md-4">
            <app-log-dialog-anchor [logs]="itemSolicitud.logs"></app-log-dialog-anchor>
          </div>
        </div>
      </div>
    </div>

    <div class="block-content">
      <mat-divider class="engie-divider"></mat-divider>
    </div>

    <div class="block-content">
      <div class="form-horizontal pad-25">
        <div class="form-group">
          <div class="col-sm-12 text-right">
            <!-- <a
              class="btn btn-naranja"
              mat-raised-button
              (click)="guardarSolicitud()"
              >Guardar</a
            > -->
            <a class="btn btn-celeste" mat-raised-button (click)="enviarSolicitud()"
              *ngIf="permiteEnviar"><mat-icon>send</mat-icon> Enviar</a>
            <a class="btn btn-naranja2" mat-raised-button
              [routerLink]="['/solicitudes-contratista']"><mat-icon>exit_to_app</mat-icon> Salir</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <pre>{{itemSolicitud | json}}</pre> -->